import { Component } from '@angular/core';
import { MonthSelectorComponent } from './month-selector.component';

@Component({
  selector: 'eid-month-selector-desktop',
  templateUrl: './month-selector-desktop.component.html',
  styleUrls: ['./month-selector-desktop.component.scss']
})
export class MonthSelectorDesktopComponent extends MonthSelectorComponent {}
